/**
 * Created by Ning Jiang on 4/4/2017.
 */

export class WixxHelper {

    public static featureToSymbols(feature:string):string[] {
        if(feature === "BASE") {
            return [];
        }

        const featureSymbolNames:string[] = feature.substr(0, feature.length - 8).split("_").map((color:string):string => {
            switch(color) {
                case "RED":
                    return "M1";
                case "YELLOW":
                    return "M2";
                case "BLUE":
                    return "M3";
                default:
                    debugger;
                    throw new Error(`WixxHelper.featureToSymbols(): Invalid feature color ${color}!`);
            }
        });

        if(featureSymbolNames.length < 1) {
            debugger;
            throw new Error(`WixxHelper.featureToSymbols(): No feature symbol found!`);
        }

        return featureSymbolNames;
    }

    public static isBoostedSymbol(symName:string):boolean {
        return symName.indexOf("boosted") > -1;
    }

    public static isMidSymbol(symName:string):boolean {
        return symName.indexOf("M") > -1;
    }
}